import { render, staticRenderFns } from "./HolidayList.vue?vue&type=template&id=1ed08351&"
import script from "./HolidayList.vue?vue&type=script&lang=ts&"
export * from "./HolidayList.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports